import React, { useState } from 'react';
import { requestPasswordReset } from '../../services/forgotPasswordService.ts';
import LogoIconSrc from './../../assets/icons/logo/pixle-transparent-inverted.png';
import './forgotPassword.css';
import { CheckCircle } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { authErrorMessage } from '../../i18n/authMessages';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await requestPasswordReset({ email });

      if (response.message) {
        setEmailSent(true);
      }
    } catch (error: any) {
      toast.error(authErrorMessage(error, 'forgot.failed'));
    }
    setLoading(false);
  };

  return (
    <div className="forgotPassword-container">
      <div className="forgotPassword-right">
        <img src={LogoIconSrc} alt="Logo Icon" />
        {emailSent ? (
          <div className="success-message">
            <CheckCircle className="success-tick" />
            <h2 className="forgotPassword-title">Password Reset Email Sent</h2>
            <p>Please check your email for the reset link.</p>
            <p className="register-text">
              Go back to <a href="/login"> Login</a>
            </p>
          </div>
        ) : (
          <>
            <h2 className="forgotPassword-title">Change Password</h2>

            <form className="forgotPassword-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email address *</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Type your email address here"
                  required
                />
              </div>

              <div className="forgotPassword-controls">
                <button
                  type="submit"
                  className="forgotPassword-button"
                  disabled={loading}
                >
                  {loading
                    ? 'Generating Reset Password Link...'
                    : 'Reset Password'}
                </button>
                <p className="register-text">
                  New to Pixle? <a href="/signup">Start your free trial</a>
                </p>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
